import { Controller } from "@hotwired/stimulus"
import api from "@/utils/api"

export default class extends Controller {
  static values = {
    autoDownload: Boolean,
    loadingHtml: String,
    downloadUrl: String
  }

  static targets = ["button"]

  connect() {
    // 최초 접근 시 자동 다운로드
    if (this.autoDownloadValue) {
      this.triggerAutoDownload()
    }

    // 원본 버튼 내용 저장
    if (this.hasButtonTarget) {
      this.originalButtonHTML = this.buttonTarget.innerHTML
    }
  }

  async downloadFile(event) {
    event.preventDefault()

    if (!this.hasButtonTarget) {
      console.error('Button target not found')
      return
    }

    this.setButtonLoading(true)

    try {
      const response = await api.downloadBlob(this.downloadUrlValue)
      const filename = this.extractFilename(response.headers)
      this.triggerBrowserDownload(response.data, filename)
    } catch (error) {
      console.error('다운로드 오류:', error)
      this.showError('다운로드 중 오류가 발생했습니다.')
      this.setButtonLoading(false)
    }
  }

  extractFilename(headers) {
    const defaultFilename = 'download.zip'

    // 1순위: 커스텀 헤더 (브라우저별 Content-Disposition 파싱 차이 회피)
    // Safari를 포함한 모든 브라우저에서 안정적으로 동작
    const encodedFilename = headers['x-download-filename']
    if (encodedFilename) {
      try {
        const decoded = decodeURIComponent(encodedFilename)
        console.log('Using X-Download-Filename header:', decoded)
        return decoded
      } catch (e) {
        console.warn('Custom header decode failed:', e)
        // fallback to Content-Disposition
      }
    }

    // 2순위: Content-Disposition 헤더 (fallback)
    const contentDisposition = headers['content-disposition']
    if (!contentDisposition) {
      console.warn('No filename headers found, using default')
      return defaultFilename
    }

    console.log('Content-Disposition header:', contentDisposition)

    // RFC 5987: filename*=UTF-8''encoded_name 형식 우선 처리
    const filenameStar = contentDisposition.match(/filename\*=UTF-8''(.+?)(?:;|$)/i)
    if (filenameStar && filenameStar[1]) {
      try {
        const decoded = decodeURIComponent(filenameStar[1])
        console.log('Decoded filename* (UTF-8):', decoded)
        return decoded
      } catch (e) {
        console.warn('Filename* decode failed:', e)
      }
    }

    // 일반 filename= 형식 처리
    const filenameMatch = contentDisposition.match(/filename[^*]=["']?([^"';]+)["']?/i)
    if (filenameMatch && filenameMatch[1]) {
      let filename = filenameMatch[1]
      console.log('Extracted filename (plain):', filename)

      // URL 디코딩 시도
      try {
        filename = decodeURIComponent(filename)
        console.log('Decoded filename:', filename)
      } catch (e) {
        console.warn('Filename decode failed, using original:', filename)
      }

      return filename
    }

    console.warn('No filename found in Content-Disposition, using default')
    return defaultFilename
  }

  triggerBrowserDownload(blob, filename) {
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')

    link.style.display = 'none'
    link.href = url
    link.download = filename

    document.body.appendChild(link)
    link.click()

    // 정리
    window.URL.revokeObjectURL(url)
    document.body.removeChild(link)
  }

  setButtonLoading(loading) {
    if (!this.hasButtonTarget) return

    this.buttonTarget.disabled = loading
    this.buttonTarget.classList.add("opacity-50", "cursor-not-allowed")

    if (loading) {
      // 로딩 상태 표시 (view에서 전달받은 HTML 사용)
      this.buttonTarget.innerHTML = this.loadingHtmlValue
    } else {
      // 원본 상태로 복원
      this.buttonTarget.innerHTML = this.originalButtonHTML
    }
  }

  triggerAutoDownload() {
    if (this.hasButtonTarget) {
      this.buttonTarget.click()
    }
  }

  showError(message) {
    alert(message)
  }
}
